<template>
  <SourcesBrowse></SourcesBrowse>
</template>

<script>
import SourcesBrowse from "@/components/sources/SourcesBrowse";
export default {
  name: "Browse",
  components: { SourcesBrowse }
};
</script>

<style scoped></style>
